import { A } from '@mobily/ts-belt'
import { createEvent, createStore, restore, sample } from 'effector'
import { loadEpgCategoriesModel } from '~/features/epg/categories/load'
import { T, nay } from '~/shared/helpers'
import { epgChannelsWidgetModel } from '~/widgets/epg/channels'
import { epgTimelineWidgetModel } from '~/widgets/epg/timeline'
import { programsLoaded } from '../lib/skeleton'
import { $live } from './epg'

// page lifecycle events
export const init = createEvent()
export const left = createEvent()
export const reset = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()
//the initial state is true because the store has an initial state of false and the skeleton is not displayed
export const $contentLoading = restore(setContentLoading, true)

/** Skeleton end*/

// page readiness flag
export const $ready = createStore(false).reset(left, reset)

sample({
  clock: [
    loadEpgCategoriesModel.$ready,
    epgChannelsWidgetModel.$activeList,
    $live,
  ],
  source: {
    categoriesReady: loadEpgCategoriesModel.$ready,
    programs: $live,
    start: epgTimelineWidgetModel.$start,
    duration: epgTimelineWidgetModel.$duration,
  },
  filter: ({ categoriesReady, programs, start, duration }) =>
    categoriesReady &&
    A.all(programs, programsLoaded([start, start + duration])),
  fn: T,
  target: $ready,
})

sample({
  clock: $ready,
  fn: nay,
  target: setContentLoading,
})
